/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Objednávka č.`
};

const da_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Ordrenr.`
};

const de_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Bestell-Nr.`
};

const en_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Order No.`
};

const es_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Pedido n°`
};

const fr_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Commande n°`
};

const hu_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Rendelés sz.`
};

const it_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Ordine n°`
};

const nl_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Bestelnummer`
};

const pl_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Zamówienie nr`
};

const pt_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Pedido nº`
};

const sv_order_no = /** @type {(inputs: {}) => string} */ () => {
	return `Beställning nr`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const order_no = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_no(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_no", locale)
	if (locale === "cs") return cs_order_no(inputs)
	if (locale === "da") return da_order_no(inputs)
	if (locale === "de") return de_order_no(inputs)
	if (locale === "en") return en_order_no(inputs)
	if (locale === "es") return es_order_no(inputs)
	if (locale === "fr") return fr_order_no(inputs)
	if (locale === "hu") return hu_order_no(inputs)
	if (locale === "it") return it_order_no(inputs)
	if (locale === "nl") return nl_order_no(inputs)
	if (locale === "pl") return pl_order_no(inputs)
	if (locale === "pt") return pt_order_no(inputs)
	return sv_order_no(inputs)
};